import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Slider } from '@mui/material';
import './RangeFilterModal.css';

export default function RangeFilterModal({ selectedFilter, openModal, setOpenModal, addRangeFilter }) {
    const [value, setValue] = useState([0, 100]);
    const [description, setDescription] = useState("");
    const [name, setName] = useState("");
    const [possibleValues, setPossibleValues] = useState([0,100]);

    useEffect(() => {
        if (selectedFilter) {
            setValue([selectedFilter.possibleValues[0], selectedFilter.possibleValues[1]]);
            setDescription(selectedFilter.description);
            setName(selectedFilter.name);
            setPossibleValues(selectedFilter.possibleValues);
        }
    }, [selectedFilter]);


    const handleClose = () => {
        setOpenModal(false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    return (
        <>
            <Dialog
                open={openModal}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            addRangeFilter({ name: name, value: value, type: "range" });
                            handleClose();
                        },
                    },
                }}
            >
                <DialogTitle>Filtrer par {name}</DialogTitle>
                <DialogContent className="modal-content">
                    <DialogContentText>
                        {description}
                    </DialogContentText>
                    <Slider getAriaLabel={() => name}
                        value={value}
                        id="range-slider"
                        min={possibleValues[0]}
                        max={possibleValues[1]}
                        onChange={handleChange}
                        valueLabelDisplay="auto"
                        marks={[
                            {
                                value: possibleValues[0],
                                label: possibleValues[0]
                            },
                            {
                                value: possibleValues[1],
                                label: possibleValues[1]
                            }
                        ]}
                        className="slider"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Annuler</Button>
                    <Button type="submit">Ajouter</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
